import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac481570")

_pushScopeId("data-v-ac481570")
const _hoisted_1 = {
  key: 0,
  class: "display-simulation"
}
const _hoisted_2 = { class: "title-2" }
const _hoisted_3 = { class: "item-name" }
const _hoisted_4 = { class: "item-value" }
const _hoisted_5 = { class: "item-name" }
const _hoisted_6 = { class: "item-value" }
const _hoisted_7 = { class: "item-name" }
const _hoisted_8 = { class: "item-value" }
const _hoisted_9 = { class: "item-name" }
const _hoisted_10 = { class: "item-value" }
const _hoisted_11 = { class: "item-name" }
const _hoisted_12 = { class: "item-value" }
const _hoisted_13 = { class: "item-name" }
const _hoisted_14 = { class: "item-value" }
const _hoisted_15 = { class: "item-name" }
const _hoisted_16 = { class: "item-value" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "item-name" }
const _hoisted_19 = {
  key: 0,
  class: "item-value"
}
const _hoisted_20 = {
  key: 1,
  class: "item-value"
}
const _hoisted_21 = { class: "item-name" }
const _hoisted_22 = {
  key: 0,
  class: "item-value"
}
const _hoisted_23 = {
  key: 1,
  class: "item-value"
}
const _hoisted_24 = { class: "item-name" }
const _hoisted_25 = { class: "item-value" }
const _hoisted_26 = { class: "title-2" }
const _hoisted_27 = { class: "item-name" }
const _hoisted_28 = { class: "item-value" }
const _hoisted_29 = { class: "item-name" }
const _hoisted_30 = { class: "item-value" }
const _hoisted_31 = { class: "item-name" }
const _hoisted_32 = { class: "item-value" }
const _hoisted_33 = { class: "item-name" }
const _hoisted_34 = { class: "item-value" }
const _hoisted_35 = { class: "item-name" }
const _hoisted_36 = { class: "item-value" }
const _hoisted_37 = { class: "item-name" }
const _hoisted_38 = { class: "item-value" }
const _hoisted_39 = { class: "item-name" }
const _hoisted_40 = { class: "item-value" }
const _hoisted_41 = { class: "item-name" }
const _hoisted_42 = { class: "item-value" }
const _hoisted_43 = { class: "title-2" }
const _hoisted_44 = { class: "item-name" }
const _hoisted_45 = { class: "item-value" }
const _hoisted_46 = { class: "item-name" }
const _hoisted_47 = { class: "item-value" }
const _hoisted_48 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-2" }, " Coût des travaux ", -1)
const _hoisted_49 = { class: "item-name" }
const _hoisted_50 = { class: "item-value" }
const _hoisted_51 = { class: "item-name" }
const _hoisted_52 = { class: "item-value" }
const _hoisted_53 = { class: "important-value" }
const _hoisted_54 = { class: "item-name" }
const _hoisted_55 = { class: "item-value" }
const _hoisted_56 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-2" }, " Aides estimatives à déduire ", -1)
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "item-name" }
const _hoisted_59 = { class: "item-value" }
const _hoisted_60 = { class: "item-name" }
const _hoisted_61 = { class: "item-value" }
const _hoisted_62 = { class: "item-name" }
const _hoisted_63 = { class: "item-value" }
const _hoisted_64 = { class: "important-value" }
const _hoisted_65 = { class: "item-name" }
const _hoisted_66 = { class: "item-value" }
const _hoisted_67 = { class: "important-value" }
const _hoisted_68 = { class: "item-name" }
const _hoisted_69 = { class: "item-value" }
const _hoisted_70 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_base_card = _resolveComponent("base-card")
  const _component_table_primes = _resolveComponent("table-primes")

  return ($props.simulation)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_base_card, { class: "base-card" }, {
          default: _withId(() => [
            _createVNode("dig-ui-title", _hoisted_2, _toDisplayString($setup.t('Simulation.contact')), 1),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_3, _toDisplayString($setup.t('Simulation.firstname')) + " : ", 1),
              _createVNode("span", _hoisted_4, _toDisplayString($props.simulation.firstname), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_5, _toDisplayString($setup.t('Simulation.lastname')) + " : ", 1),
              _createVNode("span", _hoisted_6, _toDisplayString($props.simulation.lastname), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_7, _toDisplayString($setup.t('Simulation.address')) + " : ", 1),
              _createVNode("span", _hoisted_8, _toDisplayString($props.simulation.address) + " - " + _toDisplayString($props.simulation.cp) + " - " + _toDisplayString($props.simulation.city), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_9, _toDisplayString($setup.t('Simulation.email')) + " : ", 1),
              _createVNode("span", _hoisted_10, _toDisplayString($props.simulation.email), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_11, _toDisplayString($setup.t('Simulation.phone')) + " : ", 1),
              _createVNode("span", _hoisted_12, _toDisplayString($props.simulation.phone), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_13, _toDisplayString($setup.t('Simulation.ownerType')) + " : ", 1),
              _createVNode("span", _hoisted_14, _toDisplayString($setup.t(`Simulation.OwnerType.${$props.simulation.ownerType}`)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_15, _toDisplayString($setup.t('Simulation.powerType')) + " : ", 1),
              _createVNode("span", _hoisted_16, _toDisplayString($setup.t(`Simulation.PowerType.${$props.simulation.powerType}`)), 1)
            ]),
            (!$props.simulation.noAuto)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_18, _toDisplayString($setup.t('Simulation.incomes')) + " : ", 1),
                    ($props.simulation.incomes)
                      ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString($setup.formatEuro($props.simulation.incomes)), 1))
                      : _createCommentVNode("", true),
                    (!$props.simulation.incomes)
                      ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString($setup.t(`Simulation.undefined`)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_21, _toDisplayString($setup.t('Simulation.person')) + " : ", 1),
                    ($props.simulation.person)
                      ? (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString($props.simulation.person), 1))
                      : _createCommentVNode("", true),
                    (!$props.simulation.person)
                      ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString($setup.t(`Simulation.undefined`)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_24, _toDisplayString($setup.t('Simulation.taxBracket')) + " : ", 1),
              _createVNode("span", _hoisted_25, _toDisplayString($setup.t(`Simulation.TaxBracket.${$props.simulation.taxBracket || null}`)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_base_card, { class: "base-card" }, {
          default: _withId(() => [
            _createVNode("dig-ui-title", _hoisted_26, _toDisplayString($setup.t('Simulation.works')), 1),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_27, _toDisplayString($setup.t('Simulation.works')) + " : ", 1),
              _createVNode("span", _hoisted_28, _toDisplayString($setup.t(`Simulation.WorksTypes.${$props.simulation.name}`)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_29, _toDisplayString($setup.tc(
              `Simulation.WorksPrefix.${$props.simulation.name}`,
              $props.simulation?.count || 0,
            )) + " : ", 1),
              _createVNode("span", _hoisted_30, _toDisplayString($props.simulation.count) + " " + _toDisplayString($setup.tc(
              `Simulation.WorksUnits.${$props.simulation.name}`,
              $props.simulation?.count || 0,
            )), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_31, _toDisplayString($setup.t('Simulation.priceEquipment')) + " : ", 1),
              _createVNode("span", _hoisted_32, _toDisplayString($setup.formatEuro($props.simulation.priceEquipment)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_33, _toDisplayString($setup.t('Simulation.priceWorkforce')) + " : ", 1),
              _createVNode("span", _hoisted_34, _toDisplayString($setup.formatEuro($props.simulation.priceWorkforce)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_35, _toDisplayString($setup.t('Simulation.ceePrime')) + " : ", 1),
              _createVNode("span", _hoisted_36, _toDisplayString($setup.formatEuro($props.simulation.cee[$props.simulation.taxBracket])), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_37, _toDisplayString($setup.t('Simulation.ceeName')) + " : ", 1),
              _createVNode("span", _hoisted_38, _toDisplayString($props.simulation.ceeName), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_39, _toDisplayString($setup.t('Simulation.otherPrime')) + " : ", 1),
              _createVNode("span", _hoisted_40, _toDisplayString($setup.formatEuro($props.simulation.otherPrime)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_41, _toDisplayString($setup.t('Simulation.otherName')) + " : ", 1),
              _createVNode("span", _hoisted_42, _toDisplayString($props.simulation.otherName), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_base_card, { class: "base-card" }, {
          default: _withId(() => [
            _createVNode("dig-ui-title", _hoisted_43, _toDisplayString($setup.t('Simulation.results')), 1),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_44, _toDisplayString($setup.t('Simulation.works')) + " : ", 1),
              _createVNode("span", _hoisted_45, _toDisplayString($setup.t(`Simulation.WorksTypes.${$props.simulation.name}`)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_46, _toDisplayString($setup.tc(`Simulation.WorksPrefix.${$props.simulation.name}`, $props.simulation.count)) + " : ", 1),
              _createVNode("span", _hoisted_47, _toDisplayString($props.simulation.count) + " " + _toDisplayString($setup.tc(`Simulation.WorksUnits.${$props.simulation.name}`, $props.simulation.count)), 1)
            ]),
            _hoisted_48,
            _createVNode("p", null, [
              _createVNode("span", _hoisted_49, _toDisplayString($setup.t('Simulation.priceTotalHT')) + " : ", 1),
              _createVNode("span", _hoisted_50, _toDisplayString($setup.formatEuro($props.simulation.ht)), 1)
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_51, _toDisplayString($setup.t('Simulation.priceTotalTVA')) + " : ", 1),
              _createVNode("span", _hoisted_52, _toDisplayString($setup.formatEuro($props.simulation.tva)), 1)
            ]),
            _createVNode("p", _hoisted_53, [
              _createVNode("span", _hoisted_54, _toDisplayString($setup.t('Simulation.priceTotalTTC')) + " : ", 1),
              _createVNode("span", _hoisted_55, _toDisplayString($setup.formatEuro($props.simulation.ttc)), 1)
            ]),
            _hoisted_56,
            ($props.simulation.taxBracket)
              ? (_openBlock(), _createBlock("div", _hoisted_57, [
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_58, _toDisplayString($setup.t('Simulation.cee', { name: $props.simulation.ceeName })) + " : ", 1),
                    _createVNode("span", _hoisted_59, _toDisplayString($setup.formatEuro($props.simulation.cee[$props.simulation.taxBracket] || 0)), 1)
                  ]),
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_60, _toDisplayString($setup.t('Simulation.aides', { name: $props.simulation.otherName })) + " : ", 1),
                    _createVNode("span", _hoisted_61, _toDisplayString($setup.formatEuro($props.simulation.otherPrime || 0)), 1)
                  ]),
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_62, _toDisplayString($setup.t('Simulation.primeRenov')) + " : ", 1),
                    _createVNode("span", _hoisted_63, _toDisplayString($setup.formatEuro($props.simulation.renov[$props.simulation.taxBracket] || 0)), 1)
                  ]),
                  _createVNode("p", _hoisted_64, [
                    _createVNode("span", _hoisted_65, _toDisplayString($setup.t('Simulation.total')) + " : ", 1),
                    _createVNode("span", _hoisted_66, _toDisplayString($setup.formatEuro(
                ($props.simulation.cee[$props.simulation.taxBracket] || 0) +
                  ($props.simulation.otherPrime || 0) +
                  ($props.simulation.renov[$props.simulation.taxBracket] || 0),
              )), 1)
                  ]),
                  _createVNode("p", _hoisted_67, [
                    _createVNode("span", _hoisted_68, _toDisplayString($setup.t('Simulation.resteACharge')) + " : ", 1),
                    _createVNode("span", _hoisted_69, _toDisplayString($setup.formatEuro(
                $props.simulation.ttc -
                  (($props.simulation.cee[$props.simulation.taxBracket] || 0) +
                    ($props.simulation.otherPrime || 0) +
                    ($props.simulation.renov[$props.simulation.taxBracket] || 0)),
              )), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!$props.simulation.taxBracket)
              ? (_openBlock(), _createBlock("div", _hoisted_70, [
                  _createVNode(_component_table_primes, { simulation: $props.simulation }, null, 8, ["simulation"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
})